module.exports = __webpack_public_path__ + "img/1F6AE.21678590.svg";